// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2fNZ2","loaderOuter":"PageOverlayLoader_loaderOuter__1txdE"};